'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import { DRAG_TYPES } from 'ContentEditorUI/utils/DragAndDropConstants';
import styled from 'foundations-theming/utils';
import { FLEX_COLUMN_RGB_COLORS, Z_INDEX_MAX_LAYERS } from 'InpageEditorUI/lib/layoutSection/constants';
import { DropTarget } from 'react-dnd-compat';
import { jsx as _jsx } from "react/jsx-runtime";
const dropTypes = [DRAG_TYPES.ADD_MODULE, 'WIDGETS'];
const dropSpec = {
  hover(props) {
    const {
      currentTargetDropIndex,
      dropIndex,
      updateCurrentDropTarget
    } = props;
    // Only update the current drop target if its different
    if (currentTargetDropIndex !== dropIndex) {
      updateCurrentDropTarget(dropIndex);
    }
  },
  drop(props, monitor) {
    if (monitor.didDrop() && monitor.getDropResult()) {
      return null;
    }
    const {
      currentTargetDropIndex,
      flexDropColumnId
    } = props;
    return {
      dropIndex: currentTargetDropIndex,
      flexDropColumnId
    };
  }
};
const dropCollect = monitor => ({
  isOver: monitor.isOver()
});
const DropTargetContainer = styled.div.withConfig({
  displayName: "FlexColumnEmptyDropPlaceHolder__DropTargetContainer",
  componentId: "bfsiqn-0"
})(({
  theme,
  $isOver
}) => ({
  blockSize: '50px',
  inlineSize: '100%',
  borderWidth: theme.space['25'],
  borderStyle: 'dashed',
  borderColor: FLEX_COLUMN_RGB_COLORS.DROP_TARGET_BORDER,
  background: $isOver ? FLEX_COLUMN_RGB_COLORS.DROP_TARGET_ON_HOVER_BACKGROUND : FLEX_COLUMN_RGB_COLORS.DROP_TARGET_BACKGROUND,
  position: 'relative',
  zIndex: Z_INDEX_MAX_LAYERS.LEVEL_2
}));
class FlexColumnEmptyDropPlaceHolder extends Component {
  render() {
    const {
      connectDropTarget,
      isOver
    } = this.props;
    return connectDropTarget(
    /*#__PURE__*/
    // @bend-expect trellis-tokenized .hs-private class for styled-component 'DropTargetContainer'
    _jsx("div", {
      "data-hs-dragdrop": true,
      className: "hs-private",
      children: /*#__PURE__*/_jsx(DropTargetContainer, {
        "data-test-id": "flex-column-dropzone",
        $isOver: isOver
      })
    }));
  }
}
FlexColumnEmptyDropPlaceHolder.propTypes = {
  connectDropTarget: PropTypes.func.isRequired,
  currentTargetDropIndex: PropTypes.number,
  // eslint-disable-line react/no-unused-prop-types
  dropIndex: PropTypes.number.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  flexDropColumnId: PropTypes.string.isRequired,
  // eslint-disable-line react/no-unused-prop-types
  isOver: PropTypes.bool.isRequired,
  updateCurrentDropTarget: PropTypes.func.isRequired // eslint-disable-line react/no-unused-prop-types
};
export default DropTarget(dropTypes, dropSpec, dropCollect)(FlexColumnEmptyDropPlaceHolder);